import React from 'react';
// import  GeneralHome from '../../features-csvc/components-csvc/GeneralHome'
// import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router-dom';
// import MainLayout from 'layouts/MainLayout';

import { csvcRoutes } from './csvcRoutes/newCsvcRoutes';
// import { csvcRoutes } from './csvcRoutes';
// import { router } from 'routesORIGINALE';

// import  { useSelector } from 'react-redux'
import PropTypes from 'prop-types';


export const CsvcRouterProvider = () => {
    // const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);

    /*
    switch (csvcRole) {
        case 'azienda':
        case 'partner':
            return  <RouterProvider router={csvcRoutes}/>
        case 'master':
            return  <RouterProvider router={router}/>
        default:
            return  <RouterProvider router={router}/>
    } 
    */

    return  <RouterProvider router={csvcRoutes}/>
    // return (<GeneralHome />)
}

CsvcRouterProvider.propTypes = {
    jwtToken: PropTypes.any
};

/*

    switch (csvcRole) {
        case 'azienda':
            return  <RouterProvider router={router}/>
        case 'partner':
            return  <RouterProvider router={routerPartner}/>
        case 'master':
            return  <RouterProvider router={routerMaster}/>
        default:
            return  <RouterProvider router={null}/>
    } 

*/